import styled from 'styled-components';
import colors from '../../../utils/colors';

export const OnsiteLocationMainWrapper = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: ${colors.blGrayscale1200};
	overflow: hidden;
`;

export const OnsiteLocationMainBody = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export const OnsiteLocationMainFooter = styled.div`
	position: fixed;
	bottom: 48px;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const BackButton = styled.button`
	position: absolute;
	left: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 12px 20px;
	gap: 8px;
	border-radius: 100px;
	background: transparent;

	:hover, :active {
		background:  transparent;
	}
`;

// NOTE: the onsite-location-publishing styled components were converted to SCSS
// in src/scss/modules/_onsite-location-entry.scss (publishing section).
